import React from "react";
import { useInView } from "react-intersection-observer";

// css
import * as styles from "./ProvenResults.module.css";

// Import icons
import empIcon7 from "../../../images/icons/emp-icn7.png";
import empIcon8 from "../../../images/icons/emp-icn8.png";
import empIcon9 from "../../../images/icons/emp-icn9.png";
import empIcon10 from "../../../images/icons/emp-icn10.png";
import empIcon11 from "../../../images/icons/emp-icn11.png";
import empIcon12 from "../../../images/icons/emp-icn12.png";
import empIcon13 from "../../../images/icons/emp-icn13.png";
import empIcon14 from "../../../images/icons/emp-icn14.png";
import empIcon15 from "../../../images/icons/emp-icn15.png";

const ProvenResultsComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const topResults = [
    {
      icon: empIcon7,
      value: "72%",
      description: "Diabetic members achieved Hba1c reduction in 3-6 months",
    },
    {
      icon: empIcon8,
      value: "70%+",
      description: "reduction in long-term health costs",
    },
    {
      icon: empIcon9,
      value: "₹41,000+",
      description:
        "average annual savings per employee in medication and hospitalization",
    },
    {
      icon: empIcon10,
      value: "3kg",
      description: "average weight loss and sustained energy improvement",
    },
    {
      icon: empIcon11,
      value: ">90%",
      description: "report better focus, mood, and sleep",
    },
  ];

  const bottomResults = [
    {
      icon: empIcon12,
      title: "Reduced insurance claims",
    },
    {
      icon: empIcon13,
      title: "Higher productivity & energy",
    },
    {
      icon: empIcon14,
      title: "Lower absenteeism",
    },
    {
      icon: empIcon15,
      title: "Stronger employer brand",
    },
  ];

  return (
    <section className={styles.provenResultsWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h2 className={styles.mainTitle}>PROVEN RESULTS</h2>
              <h3 className={styles.subTitle}>
                Employee Care Programme That Drives Real Business ROI with Evergreen
              </h3>
              <p className={styles.description}>
                Our employee metabolic care program delivers measurable outcomes for
                better metabolic health and stronger productivity.
              </p>
            </div>
          </div>
        </div>

        {/* Top Results Grid */}
        <div className="row">
          <div className="col-12">
            <div className={styles.topResultsGrid}>
              {topResults.map((result, index) => (
                <div key={index} className={styles.resultCard}>
                  <div className={styles.resultIcon}>
                    <img
                      src={result.icon}
                      alt={result.value}
                      className={styles.iconImage}
                    />
                  </div>
                  <h4 className={styles.resultValue}>{result.value}</h4>
                  <p className={styles.resultDescription}>
                    {result.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Middle Section */}
        <div className="row">
          <div className="col-12">
            <div className={styles.middleSection}>
              <h3 className={styles.middleTitle}>
                For employers, these outcomes mean
              </h3>
            </div>
          </div>
        </div>

        {/* Bottom Results Grid */}
        <div className="row">
          <div className="col-12">
            <div className={styles.bottomResultsGrid}>
              {bottomResults.map((result, index) => (
                <div key={index} className={styles.bottomResultCard}>
                  <div className={styles.bottomResultIcon}>
                    <img
                      src={result.icon}
                      alt={result.title}
                      className={styles.bottomIconImage}
                    />
                  </div>
                  <p className={styles.bottomResultTitle}>{result.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div className="row">
          <div className="col-12">
            <div className={styles.footerSection}>
              <p className={styles.footerText}>
                Healthy employees are not just happier — they power stronger
                businesses.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvenResultsComponent;
